"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _autoSql = _interopRequireDefault(require("./autoSql"));

var _defaultTypes = _interopRequireDefault(require("./defaultTypes"));

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var strandMap = {
  ".": 0,
  "-": -1,
  "+": 1
}; // heuristic that a BED file is BED12 like...the number in col 10 is blockCount-like

function isBed12Like(fields) {
  var _fields$;

  return fields.length >= 12 && !Number.isNaN(parseInt(fields[9], 10)) && ((_fields$ = fields[10]) === null || _fields$ === void 0 ? void 0 : _fields$.split(",").filter(function (f) {
    return !!f;
  }).length) === parseInt(fields[9], 10);
}

var BED = /*#__PURE__*/function () {
  function BED() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, BED);

    if (args.autoSql) {
      this.autoSql = (0, _util.detectTypes)(_autoSql.default.parse(args.autoSql));
    } else if (args.type) {
      if (!_defaultTypes.default[args.type]) {
        throw new Error("Type not found");
      }

      this.autoSql = (0, _util.detectTypes)(_defaultTypes.default[args.type]);
    } else {
      this.autoSql = (0, _util.detectTypes)(_defaultTypes.default.defaultBedSchema);
      this.attemptDefaultBed = true;
    }
  }
  /*
   * parses a line of text as a BED line with the loaded autoSql schema
   *
   * @param line - a BED line as tab delimited text or array
   * @param opts - supply opts.uniqueId
   * @return a object representing a feature
   */


  _createClass(BED, [{
    key: "parseLine",
    value: function parseLine(line) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var autoSql = this.autoSql;
      var uniqueId = opts.uniqueId;
      var fields = line;

      if (!Array.isArray(line)) {
        if (line.startsWith("track") || line.startsWith("browser")) {
          throw new Error("track and browser line parsing is not supported, please filter:\n".concat(line));
        }

        fields = line.split("\t");
      }

      var feature = {};

      if (!this.attemptDefaultBed || this.attemptDefaultBed && isBed12Like(fields)) {
        for (var i = 0; i < autoSql.fields.length; i++) {
          var autoField = autoSql.fields[i];
          var columnVal = fields[i];
          var isNumeric = autoField.isNumeric,
              isArray = autoField.isArray,
              arrayIsNumeric = autoField.arrayIsNumeric,
              name = autoField.name;

          if (columnVal === null || columnVal === undefined) {
            break;
          }

          if (columnVal !== ".") {
            if (isNumeric) {
              var num = Number(columnVal);
              columnVal = Number.isNaN(num) ? columnVal : num;
            } else if (isArray) {
              columnVal = columnVal.split(",");

              if (columnVal[columnVal.length - 1] === "") {
                columnVal.pop();
              }

              if (arrayIsNumeric) {
                columnVal = columnVal.map(function (str) {
                  return Number(str);
                });
              }
            }

            feature[name] = columnVal;
          }
        }
      } else {
        var fieldNames = ["chrom", "chromStart", "chromEnd", "name"];
        feature = Object.fromEntries(fields.map(function (f, i) {
          return [fieldNames[i] || "field" + i, f];
        }));
        feature.chromStart = +feature.chromStart;
        feature.chromEnd = +feature.chromEnd;

        if (!Number.isNaN(Number.parseFloat(feature.field4))) {
          feature.score = +feature.field4;
          delete feature.field4;
        }

        if (feature.field5 === "+" || feature.field5 === "-") {
          feature.strand = feature.field5;
          delete feature.field5;
        }
      }

      if (uniqueId) {
        feature.uniqueId = uniqueId;
      }

      feature.strand = strandMap[feature.strand] || 0;
      feature.chrom = decodeURIComponent(feature.chrom);
      return feature;
    }
  }]);

  return BED;
}();

exports.default = BED;